const LandingDevStepsItemRight = ({number, title, description, icon}) => {
    return (
        <div className="p-10">
            <div className="flex flex-col sm:flex-row md:flex-row lg:flex-row xl:flex-row justify-evenly gap-y-10">
                <div className="hidden sm:block md:block lg:block xl:block">
                    <img src={icon} alt="icon" className="w-36 sm:w-52 md:w-64 lg:w-64 xl:w-64 grow"/>
                </div>
                <div className="sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
                    <div className="relative">
                        <p className="text-accent font-bold text-9xl">{number}</p>
                        <p className="font-semibold absolute text-4xl bottom-2">{title}</p>
                    </div>
                    <p className="mt-2">{description}</p>
                </div>
                {/* mobile view */}
                <div className="sm:hidden md:hidden lg:hidden xl:hidden">
                    <img src={icon} alt="icon" className="w-36 sm:w-52 md:w-64 lg:w-64 xl:w-64 grow"/>
                </div>
            </div>
        </div>
    )
}

export default LandingDevStepsItemRight